<mat-card class="filter settingHeader">
  <div class="name">
    Project Status Report
  </div>

  <div class="projectSearch">
      
    <button class="searchbtn" [disabled]="value==''"  mat-icon-button aria-label="Clear">
      <mat-icon (click)="SearchFilter()">search</mat-icon>
    </button>
   
    <input placeholder="Search" type="text"  maxlength="50" [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" />
   
    <button class="filterbtn" mat-icon-button (click)="applyAdvFilter(advFilter)"
    matTooltipClass="tooltip" matTooltip="Filters">
   <mat-icon>filter_list</mat-icon>
  </button>
 

 </div>


  <!-- <div class="quickAction">
    <mat-form-field class="example-form-field" appearence="fill">
      <mat-label>Search Record</mat-label>
      <input matInput type="text"  [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" >
      <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>close</mat-icon>
      </button>
      <button  *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
   
  </div> -->

</mat-card>

<mat-card class="documents">
  <table class="mat-table" *ngIf="!ShowNoRecordFound">
    <thead>
      <tr class="mat-header-row">
        <!-- <th class="mat-header-cell">SNo</th> -->
        <th class="mat-header-cell">From</th>
        <th class="mat-header-cell">Project Name</th>
        <th class="mat-header-cell">Date</th>
        <th class="mat-header-cell pEmail">Name</th>
        <th class="mat-header-cell pEmail">Participant Emails</th>
        <th class="mat-header-cell pEmail">Form Name</th>
        <th class="mat-header-cell">Office</th>
        <th class="mat-header-cell">Organization</th>
        <th class="mat-header-cell">Status</th>
        <th class="mat-header-cell">Docs link</th> 
        <th class="mat-header-cell">Docs</th>
        <th class="mat-header-cell">Type</th>   
        <th class="mat-header-cell">Action</th>     
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let project of projects; let i = index" class="mat-row">
        <!-- <td class="mat-cell">{{ i + 1 }}</td> -->
        <td class="mat-cell">             
          <p *ngIf="project.pType==0"><mat-icon matTooltip="Sign Now">border_color</mat-icon></p>
          <p *ngIf="project.pType==1"><mat-icon matTooltip="Fill">description</mat-icon></p> 
        </td> 
        <td class="mat-cell" *ngIf="project.participants" matTooltip="{{project.projectName}}" matTooltipClass="tooltip">{{ project.projectName }}</td>
        <td class="mat-cell" *ngIf="!project.participants">--</td>
        <td class="mat-cell"  matTooltipClass="tooltip">{{ project.createdOn | date: "MM/dd/yyyy" }}</td>
        
        <td class="mat-cell pEmail" matTooltip="{{project.name}}" matTooltipClass="tooltip">
          
          <ng-container *ngFor="let name of getParticipant(project.name);let i = index">            
            <span *ngIf="i == 0" >{{name}}</span>
            <span class="count" *ngIf="getParticipant(project.participants).length > 1 && i == 1" > + {{getParticipant(project.name).length - 1}}</span>                 
        </ng-container>     
        
        
        </td>
        
        <td class="mat-cell pEmail" *ngIf="project.participants" matTooltip="{{project.participants}}" matTooltipClass="tooltip">          
          <ng-container *ngFor="let name of getParticipant(project.participants);let i = index">            
              <span *ngIf="i == 0" >{{name}}</span>
              <span class="count" *ngIf="getParticipant(project.participants).length > 1 && i == 1" > + {{getParticipant(project.participants).length - 1}}</span>                 
          </ng-container>                  
        </td>

        <td class="mat-cell" *ngIf="!project.participants">--</td>
        <td class="mat-cell pEmail"  matTooltip="{{project.formName}}" matTooltipClass="tooltip"><p>{{ project.formName }}</p></td>
        <td class="mat-cell"  matTooltip="{{project.officeName}}" matTooltipClass="tooltip"><p>{{ project.officeName }}</p></td>
        <td class="mat-cell"  matTooltip="{{project.orgName}}" matTooltipClass="tooltip"><p>{{ project.orgName }}</p></td>
        <td class="mat-cell" matTooltipClass="tooltip"><p>{{ project.projectStatus }}</p></td>
        <td class="mat-cell">
          <ng-container *ngFor="let link of project.linksToCompletedDocuent;let i=index" >
            <a class="multiLink" [href]="link" target="_blank">
              {{i+1}}              
            </a>
          </ng-container>
          
          <span *ngIf="project.linksToCompletedDocuent==null || project.linksToCompletedDocuent.length==0">--</span>
        </td>

        <td class="mat-cell">
          <button  color="primary" mat-icon-button *ngIf="project.linksToCompletedDocuent && project.linksToCompletedDocuent.length" (click)="downloadAsZip(project)">
            <mat-icon>folder_zip</mat-icon>
          </button>      
        </td>
        <td class="mat-cell">
          <p *ngIf="project.coreID>0"><mat-icon matTooltip="{{CoreShowName}}">app_registration</mat-icon></p>
          <p *ngIf="project.contactID>0"><mat-icon matTooltip="{{ContactShowName}}">contact_mail</mat-icon></p>
        </td>
        <td class="mat-cell">
          <button *ngIf="project.projectStatus !== 'Completed'" color="primary" mat-icon-button (click)="SendRemainder(project)">
          <mat-icon>notifications_active</mat-icon>
        </button>
        
         <button *ngIf="project.projectStatus == 'Completed'" color="primary" mat-icon-button matTooltip="Sync Documents"
         (click)="mapPlaceHolder(project)">
         <mat-icon>sync</mat-icon>
         </button>
       </td>
       
      </tr>
    </tbody>
  </table>
  <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>
</mat-card>


<ng-template #advFilter>

  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>view_column</mat-icon>
    </span>
     Search
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>   
  </h2>

  <mat-dialog-content class="mat-typography">

    <div class="allheaders">    
      
      <mat-form-field appearance="" *ngIf="showSuperAdmin==true">
        <mat-label>Organization Name</mat-label>
        <mat-select placeholder = "Select Organization"  
          (selectionChange)="getOffice($event)">
           <mat-option *ngFor = "let data of OrgnizationList" 
              [value] = "data.organizationID">
              {{data.organizationName}}
           </mat-option>
        </mat-select>
      </mat-form-field> 

      <mat-form-field appearance="" *ngIf="showOrganizationAdmin==true">
        <mat-label>Office Name</mat-label>
        <mat-select placeholder = "Select Office" [(ngModel)]="selectedOfficeId" (selectionChange)="selectOffice($event)">
          <mat-option *ngFor = "let data of OrgOfficeList" 
             [value] = "data.officeID">
             {{data.officeName}}
          </mat-option>
       </mat-select>
      </mat-form-field> 

      <mat-form-field appearance="" *ngIf="showUserAdmin==true">
        <mat-label>User Name</mat-label>
        <mat-select placeholder = "Select User" [(ngModel)]="selecteduserId" (selectionChange)="selectUser($event)">
          <mat-option *ngFor = "let data of UsersList" 
             [value] = "data.uuid">
             {{data.firstName}} {{data.lastName}} 
          </mat-option>
       </mat-select>
      </mat-form-field> 
      
    <mat-form-field class="example-half-width">                
        <mat-label>Owner Name/Email</mat-label>
        <input matInput placeholder="Owner Name/Email" [(ngModel)]="emailAdvSearch">
    </mat-form-field>

      <!-- <section class="example-section">
        <mat-checkbox color="primary" (change)="getCheckboxValues($event, 1)">Sent</mat-checkbox> &nbsp;&nbsp;
        <mat-checkbox color="primary" (change)="getCheckboxValues($event, 2)">In Progress</mat-checkbox>&nbsp;&nbsp;
        <mat-checkbox color="primary" (change)="getCheckboxValues($event, 3)">Completed</mat-checkbox>
      </section> -->
     

   <div class="d-flex">
    <div class="w5">
      <mat-form-field class="example-full-width" appearance="">
        <mat-label>Choose from date</mat-label>
        <input matInput [matDatepicker]="picker1"  (dateChange)="onFromDateChange($event)"  readonly>
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>     
    </div>
          
      
    <div class="w5">
      <mat-form-field class="example-full-width" appearance="">
        <mat-label>Choose to date</mat-label>
        <input matInput [matDatepicker]="picker2" 
        (dateChange)="onToDateChange($event)"  readonly>
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>    
    </div>
   </div>

   

  <mat-form-field appearance="">
    <mat-label>Form Name</mat-label>
    <mat-select placeholder = "Select Form"  [(ngModel)]="selectedFormId"  (selectionChange)="formNameSelection($event)">
      <mat-option *ngFor="let form of formList" [value]="form.formID">
        {{ form.formName }}
      </mat-option>
    </mat-select>
  </mat-form-field> 



    </div>

  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-flat-button class="calltoaction" type="submit"             
    (click)="searchAdvFilter()" color="primary">
       Search
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
      </mat-spinner></mat-icon>
    </button>

    <button mat-flat-button class="calltoaction" type="submit"             
    (click)="clear()" color="primary">
      Clear      
    </button>
  </mat-dialog-actions>

</ng-template>

<app-loader></app-loader>